import { render, staticRenderFns } from "./FolderNavigator.vue?vue&type=template&id=4fdc7246&scoped=true"
import script from "./FolderNavigator.vue?vue&type=script&lang=ts"
export * from "./FolderNavigator.vue?vue&type=script&lang=ts"
import style0 from "./FolderNavigator.vue?vue&type=style&index=0&id=4fdc7246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc7246",
  null
  
)

export default component.exports